module.exports = __webpack_public_path__ + "static/media/Linkedin.7d35009e.svg";